import CommomProxy from '@/components/proxy/CommomProxy'

let child_routes = [

    {
        path: '/promotion/',
        name: 'index',
        component: resolve => {
            require(['@/views/promotion/index'], resolve);
        },
        meta: {
            title: '健康快乐100岁服务调查'
        }
    },
    {
        path: '/promotion/indexq',
        name: 'indexq',
        component: resolve => {
            require(['@/views/promotion/indexq'], resolve);
        },
        meta: {
            title: '健康快乐100岁服务调查'
        }
    },
    {
        path: '/promotion/indexu',
        name: 'indexu',
        component: resolve => {
            require(['@/views/promotion/indexu'], resolve);
        },
        meta: {
            title: '健康快乐100岁服务调查'
        }
    },
    {
        path: '/promotion/indexe',
        name: 'indexe',
        component: resolve => {
            require(['@/views/promotion/indexe'], resolve);
        },
        meta: {
            title: '健康快乐100岁服务调查'
        }
    },
    {
        path: '/promotion/indexs',
        name: 'indexs',
        component: resolve => {
            require(['@/views/promotion/indexs'], resolve);
        },
        meta: {
            title: '健康快乐100岁服务调查'
        }
    },
    {
        path: '/promotion/indext',
        name: 'indext',
        component: resolve => {
            require(['@/views/promotion/indext'], resolve);
        },
        meta: {
            title: '健康快乐100岁服务调查'
        }
    },
    {
        path: '/promotion/indexi',
        name: 'indexi',
        component: resolve => {
            require(['@/views/promotion/indexi'], resolve);
        },
        meta: {
            title: '健康快乐100岁服务调查'
        }
    },
    {
        path: '/promotion/indexo',
        name: 'indexo',
        component: resolve => {
            require(['@/views/promotion/indexo'], resolve);
        },
        meta: {
            title: '健康快乐100岁服务调查'
        }
    },
    {
        path: '/promotion/indexn',
        name: 'indexn',
        component: resolve => {
            require(['@/views/promotion/indexn'], resolve);
        },
        meta: {
            title: '健康快乐100岁服务调查'
        }
    },
    {
        path: '/promotion/indexh',
        name: 'indexh',
        component: resolve => {
            require(['@/views/promotion/indexh'], resolve);
        },
        meta: {
            title: '健康快乐100岁服务调查'
        }
    },
    {
        path: '/promotion/indexw',
        name: 'indexw',
        component: resolve => {
            require(['@/views/promotion/indexw'], resolve);
        },
        meta: {
            title: '健康快乐100岁服务调查'
        }
    },
    {
        path: '/promotion/wxCardSend/index',
        name: 'wxCardSendIndex',
        component: resolve => {
            require(['@/views/promotion/wxCardSend/index'], resolve);
        },
        meta: {
            title: '泓华医疗视频门诊体验卡'
        }
    },
    {
        path: '/epidemic',
        name: 'wxEpidemic',
        component: resolve => {
            require(['@/views/promotion/wxCardSend/wxEpidemic'], resolve);
        },
        meta: {
            title: ''
        }
    },
    {
        path: '/prevention',
        name: 'wxPrevention',
        component: resolve => {
            require(['@/views/promotion/wxCardSend/wxPrevention'], resolve);
        },
        meta: {
            title: ''
        }
    },
    {
        path: '/extensionImg',
        name: 'extensionImg',
        component: resolve => {
            require(['@/views/promotion/wxCardSend/extensionImg'], resolve);
        },
        meta: {
            title: ''
        }
    },
	{
	    path: '/promotion/wxCardSend/epidemic',
	    name: 'epidemic',
	    component: resolve => {
	        require(['@/views/promotion/wxCardSend/epidemic'], resolve);
	    },
	    meta: {
	        title: ''
	    }
	},
	{
	    path: '/promotion/wxCardSend/epidemic_tj',
	    name: 'epidemic2',
	    component: resolve => {
	        require(['@/views/promotion/wxCardSend/epidemic2'], resolve);
	    },
	    meta: {
	        title: ''
	    }
	},
	// {
 //      path: '/promotion/wxCardSend/epidemic_rs',
 //      name: 'epidemic3',
 //      component: resolve => {
 //          require(['@/views/promotion/wxCardSend/epidemic3'], resolve);
 //      },
 //      meta: {
 //          title: '人保寿险免费领取视频门诊'
 //      }
	// },
	// {
 //      path: '/promotion/wxCardSend/newView',
 //      name: 'newView',
 //      component: resolve => {
 //          require(['@/views/promotion/wxCardSend/newView'], resolve);
 //      },
 //      meta: {
 //          title: '视频门诊'
 //      }
	// },
  {
      path: '/promotion/wxCardSend/epidemic_dt',
      name: 'epidemic4',
      component: resolve => {
          require(['@/views/promotion/wxCardSend/epidemic4'], resolve);
      },
      meta: {
          title: '泓华医疗视频问诊卡'
      }
  },
	{
	    path: '/promotion/wxCardSend/prevention',
	    name: 'prevention',
	    component: resolve => {
	        require(['@/views/promotion/wxCardSend/prevention'], resolve);
	    },
	    meta: {
	        title: ''
	    }
	},
	{
	    path: '/promotion/wxCardSend/prevention_sc',
	    name: 'prevention',
	    component: resolve => {
	        require(['@/views/promotion/wxCardSend/prevention2'], resolve);
	    },
	    meta: {
	        title: '中国搜索联合泓华视频咨询公益行'
	    }
	},
    {
        path: '/promotion/wxCardSend/physicalCard',
        name: 'wxCardSendPhysical',
        component: resolve => {
            require(['@/views/promotion/wxCardSend/physicalCard'], resolve);
        },
        meta: {
            title: '泓华医疗健康卡'
        }
    },
    {
        path: '/promotion/wxCardSend/success',
        name: 'wxCardGetSuccess',
        component: resolve => {
            require(['@/views/promotion/wxCardSend/success'], resolve);
        },
        meta: {
            title: '泓华医疗'
        }
    },
    {
        path: '/promotion/dragonBoat/index',
        name: 'dragonBoatIndex',
        component: resolve => {
            require(['@/views/promotion/dragonBoat/index'], resolve);
        },
        meta: {
            title: '父亲节特惠'
        }
    },
    {
        path: '/promotion/experience/entry',
        name: 'experienceEntry',
        component: resolve => {
            require(['@/views/promotion/experience/entry'], resolve);
        },
        meta: {
            title: '视频问诊1元活动'
        }
    },
    {
        path: '/promotion/experience/index',
        name: 'experienceIndex',
        component: resolve => {
            require(['@/views/promotion/experience/index'], resolve);
        },
        meta: {
            title: '视频问诊1元活动'
        }
    },
    {
        path: '/promotion/experience/login',
        name: 'experienceLogin',
        component: resolve => {
            require(['@/views/promotion/experience/login'], resolve);
        },
        meta: {
            title: '注册'
        }
    },
    {
        path: '/promotion/experience/success',
        name: 'experienceSuccess',
        component: resolve => {
            require(['@/views/promotion/experience/success'], resolve);
        },
        meta: {
            title: '支付结果'
        }
    },
    {
        path: '/promotion/clinic/index',
        name: 'clinicIndex',
        component: resolve => {
            require(['@/views/promotion/clinic/index'], resolve);
        },
        meta: {
            title: '普惠门诊服务'
        }
    },
    {
	    path: '/promotion/wxCardSend/prevention_cli',
	    name: 'prevention',
	    component: resolve => {
	        require(['@/views/promotion/wxCardSend/prevention3'], resolve);
	    },
	    meta: {
	        title: '视频门诊免费送'
	    }
	},
    {
	    path: '/promotion/wxCardSend/global_epidemic',
	    name: 'global_epidemic',
	    component: resolve => {
	        require(['@/views/promotion/wxCardSend/global_epidemic'], resolve);
	    },
	    meta: {
	        title: ''
	    }
    },
    {
      path: '/promotion/wxCardSend/global_epidemic2',
      name: 'global_epidemic2',
      component: resolve => {
          require(['@/views/promotion/wxCardSend/global_epidemic2'], resolve);
      },
      meta: {
          title: ''
      }
    },
	{
	  path: '/promotion/wxCardSend/downLoad',
	  name: 'downLoad',
	  component: resolve => {
	      require(['@/views/promotion/wxCardSend/downLoad'], resolve);
	  },
	  meta: {
	      title: ''
	  }
	},
	{
	  path: '/promotion/wxCardSend/downLoad2',
	  name: 'downLoad2',
	  component: resolve => {
	      require(['@/views/promotion/wxCardSend/downLoad2'], resolve);
	  },
	  meta: {
	      title: ''
	  }
	}
]


let route = [{
    path: '/promotion',
    component: CommomProxy,
    children: child_routes
}]

export default route



// WEBPACK FOOTER //
// ./src/router/promotion.js